module.exports = __webpack_public_path__ + "static/media/game-preview.61507cd6.png";